<div id="top" class="fullwidth" *ngIf="loaded">
  <div class="top" [class.gradient-top]="colors.primaryColor2" >
    <div class="headline">
      <h1 *ngIf="fair.settings.partOfCollection?.length === 0" class="overline">{{ fair.settings.overline }}</h1>
      <div class="backButtonWrapper" *ngIf="fair.settings.partOfCollection?.length > 0">
        <button mat-icon-button routerLink="..">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="overline">{{ fair.settings.overline }}</h1>
      </div>
      <h1>{{ fair.settings.headline }}</h1>
      <p [innerHtml]="fair.settings.text | safeHTML"></p>
    </div>

    <mat-form-field appearance="outline" class="searchBooth" *ngIf="!mobile">
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let tag of searchedTags" selectable="true" removable="true" (removed)="removeTagFilter(tag)">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          #tagsInput
          [placeholder]="searchText"
          (keyup)="searchBooths(true)"
          [formControl]="tagsCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          (matChipInputTokenEnd)="addTagFilter($event)"
        />
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTagOption($event)">
        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
          {{ tag }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="booth-rooms bottom">
    <swiper
      *ngIf="!mobile"
      #swiperOverview
      (slideChange)="onSlideChange($event)"
      [navigation]="true"
      [centeredSlides]="true"
      [slidesPerView]="'auto'"
      [spaceBetween]="-200"
      [mousewheel]="true"
      [pagination]="{ clickable: true, dynamicBullets: true }"
      [(index)]="currentSlide"
    >
      <ng-template swiperSlide *ngFor="let booth of swiperBooths">
        <div class="slide-content" (click)="switch(booth)">
          <h1 class="booth-name" *ngIf="booth.settings.enableName || booth.settings.enableName === undefined">{{ booth.settings.name }}</h1>
          <img class="booth-img" [src]="booth.settings.sliderImg | safe" />
        </div>
      </ng-template>
    </swiper>
    <div *ngIf="mobile" style="display: flex; flex-wrap: wrap; gap: 16px;">
      <div class="mobile-wrapper" *ngFor="let booth of swiperBooths">
        <div class="slide-content" (click)="switch(booth)">
          <h1 class="booth-name" *ngIf="booth.settings.enableName || booth.settings.enableName === undefined">
            {{ booth.settings.name }}
          </h1>
          <img class="booth-img" [src]="booth.settings.sliderImg | safe" />
        </div>
      </div>
      <div id="stylingHelper" style="width: calc(50vw - 40px + 16px);"></div>
      <button (click)="scrollToTop()" style="margin-left: auto;" mat-mini-fab aria-label="Back to top button">
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>
  </div>
</div>

<div *ngIf="loaded && boothOpen" class="boothOpen">
  <swiper
    #swiperDetail
    (slideChange)="onSlideChange($event)"
    [navigation]="true"
    [centeredSlides]="true"
    [slidesPerView]="10"
    [centeredSlides]="true"
    [(index)]="currentSlide"
  >
    <ng-template swiperSlide *ngFor="let booth of swiperBooths">
      <div class="slide-content">
        <img (click)="switch(booth)" class="booth-img" [src]="booth.settings.sliderImg | safe" />
      </div>
    </ng-template>
  </swiper>
</div>
